import React from 'react';
import { X } from 'lucide-react';

interface ProfileEditModalProps {
    isOpen: boolean;
    onClose: () => void;
    title: string;
    description?: string;
    children: React.ReactNode;
    zIndex?: number;
    headerActions?: React.ReactNode;
}

const ProfileEditModal: React.FC<ProfileEditModalProps> = ({
    isOpen,
    onClose,
    title,
    description,
    children,
    zIndex = 60,
    headerActions
}) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center" style={{ zIndex }}>
            {/* Backdrop */}
            <div
                className="absolute inset-0 bg-black/60 backdrop-blur-sm"
                onClick={onClose}
            />

            {/* Modal Content */}
            <div className="relative w-full max-w-4xl max-h-[90vh] bg-gray-50 rounded-2xl shadow-2xl overflow-hidden flex flex-col animate-scale-in">
                {/* Header */}
                <div className="px-6 py-4 bg-white border-b border-gray-100 flex items-center justify-between shrink-0">
                    <div className="flex-1">
                        <h2 className="text-xl font-bold text-gray-900">{title}</h2>
                        {description && <p className="text-sm text-gray-500 mt-0.5">{description}</p>}
                    </div>

                    <div className="flex items-center gap-3">
                        {headerActions}
                        <button
                            onClick={onClose}
                            className="w-10 h-10 rounded-full hover:bg-gray-100 flex items-center justify-center transition-colors"
                        >
                            <X className="w-6 h-6 text-gray-400" />
                        </button>
                    </div>
                </div>

                {/* Form Content - Scrollable */}
                <div className="flex-1 overflow-y-auto p-6">
                    <div className="max-w-3xl mx-auto">
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProfileEditModal;
